import { createContext } from 'react';
import ReconnectingWebSocket from 'reconnecting-websocket';

// Typdefinition für den Context
type SocketContextType = {
    socket: ReconnectingWebSocket | null;
    addMessageHandler: (type: string, handler: (data: any) => void) => void;
};

export const SocketContext = createContext<SocketContextType>({
    socket: null,
    addMessageHandler: () => {},
});
